import React from "react";
import { Link } from "react-router-dom";
import "../styles/TwentyTwentysixContent.css";

export default function JoinPage() {
  return (
    <div className="twentytwentysix-content">
      <div className="twentytwentysix-content__container">
        <p className="twentytwentysix-content__eyebrow">The Mamahood</p>
        <h1 className="twentytwentysix-content__title">Become a Member</h1>
        <p className="twentytwentysix-content__copy">
          Join our free community of Bay Area mamas. Get access to chat groups, articles, podcasts, events, and resources. No cost — just connection.
        </p>
        <div className="twentytwentysix-content__cta-row">
          <Link to="/twentytwentysix" className="twentytwentysix-content__pill">Back to Home</Link>
        </div>

        <section className="twentytwentysix-content__section">
          <h2 className="twentytwentysix-content__subtitle">What you get</h2>
          <ul className="twentytwentysix-content__list">
            <li>Topic-specific chat groups</li>
            <li>Inspiration and articles by moms for moms</li>
            <li>Podcasts and events</li>
            <li>Curated resources and the M List</li>
            <li>Local chapters: Bay Area, Sacramento Valley, LA County</li>
          </ul>
          <p className="twentytwentysix-content__copy">
            Ready to join? Sign up below or head to the main site to create your account.
          </p>
          <div className="twentytwentysix-content__cta-row">
            <Link to="/twentytwentysix/login" className="twentytwentysix-content__pill">Sign in</Link>
          </div>
        </section>
      </div>
    </div>
  );
}
